import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { DeactivateAccountContextImport } from "../../../../provider/deactivate_account/DeactivateAccountContextProvider";

const DeactivateAccountReasonButtons = (props: {
  type?: number | undefined;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const { showDeleteConfirmation } = DeactivateAccountContextImport();

  return (
    <div style={{ width: type === 3 ? 300 : `100%` }}>
      <ButtonSingle handleClick={() => showDeleteConfirmation()}>
        {AppTranslation.text("submit")}
      </ButtonSingle>
    </div>
  );
};

export default DeactivateAccountReasonButtons;
